var getLastNumberFromString = function (input) {
    var regex = /(\d+)(?!.*\d)$/;
    var match = regex.exec(input);
    if (match) {
        var id = match[1];
        return parseInt(id);
    }
    return null;
};
/**
 * Get an id from location based on url or GET params:
 *
 * 1. first try to get ID from www.url.com/page?_mensenlinqPersonId=some-string-with-123
 * 2. then try to get ID from www.url.com/page?id=some-string-with-123
 * 2. then try to get ID from www.url.com/page?persoon=some-string-with-123
 * 3. then try to get ID from www.url.com/page/some-string-with-123
 * @return id when found, null when nothing is found.
 * @param location
 */
var getIdFromLocation = function (location) {
    var urlParams = new URLSearchParams(location.search);
    var idFromPersonId = getLastNumberFromString(urlParams.get('_mensenlinqPersonId'));
    if (idFromPersonId) {
        return idFromPersonId;
    }
    var idFromGetId = getLastNumberFromString(urlParams.get('id'));
    if (idFromGetId) {
        return idFromGetId;
    }
    var idFromGetPersoon = getLastNumberFromString(urlParams.get('persoon'));
    if (idFromGetPersoon) {
        return idFromGetPersoon;
    }
    var idFromPath = getLastNumberFromString(location.pathname);
    if (idFromPath) {
        return idFromPath;
    }
    return null;
};
export default getIdFromLocation;
